import React, {useState} from 'react'
import './style.css'
import {Grid, Typography} from '@mui/material'
import ForgotForm, {ForgotFormState} from './ForgotForm'
import {useNavigate} from 'react-router'
import PageSEO from '../../components/seo/PageSEO'

const ForgotPassword = () => {

  const navigate = useNavigate()

  const [state, setState] = useState<ForgotFormState>({
    resetSuccessful: false,
    errorMessage: ''
  })

  return (
    <section>
      {/* Crawlable but out of search (securspace-ui#3107). */}
      <PageSEO title="Forgot Password | SecurSpace" description="Reset the password for your SecurSpace account." noindex/>
      <div className="ss-forgot-password-container"/>
      <Grid className='ss-forgot-password-section-container' container direction='column' justifyContent='center'
            alignItems='center'>
        <Grid className='ss-forgot-password-content-container'>
          <Typography component='h1' className='ss-forgot-password-title'>Forgot your password?</Typography>
          {!state.resetSuccessful ?
            <Typography component='p' id='forgot-password-instructions' className='ss-forgot-password-subtitle'>
              Enter your email address to reset your password. You may need to check your spam folder or unblock
              {' '}<strong className='ss-forgot-password-support-email'>donotreply@secur.space</strong>
            </Typography> : ''
          }
          <ForgotForm
            state={state}
            setState={setState}
          />
          <Grid className='ss-forgot-password-footer' container justifyContent='center' alignItems='center'>
            <Typography className='ss-forgot-password-account-title'>Remembered your account details?</Typography>
            <Typography component={"a"} onClick={() => navigate("/login")}
                        className='ss-forgot-password-signup'>{" "} Log In</Typography>
          </Grid>
        </Grid>
      </Grid>
    </section>
  )
}

export default ForgotPassword
